export default class Matricula {
  constructor({
    id,
    pessoaId,
    observacao,
    observacoesGerais,
    idiomaId,
    idiomaDescricao,
    periodoLetivoId,
    descontos,
    codigoMatricula,
    escolaOrigemId,
    nome,
    vinculos = [],
    fichaSaude = new FichaSaude({}),
  }) {
    this.id = id;
    this.pessoaId = pessoaId;
    this.observacao = observacao;
    this.observacoesGerais = observacoesGerais;
    this.idiomaId = idiomaId;
    this.idiomaDescricao = idiomaDescricao;
    this.periodoLetivoId = periodoLetivoId;
    this.descontos = descontos;
    this.vinculos = vinculos;
    this.nome = nome;
    this.codigoMatricula = codigoMatricula;
    this.fichaSaude = fichaSaude;
    this.escolaOrigemId = escolaOrigemId;
  }

  atualizarFichaSaude(fichaSaude){
    this.fichaSaude = new FichaSaude(fichaSaude);
  }

  get payload(){
    const lista = [];

    this.fichaSaude.deficienciaAuditiva && lista.push('Auditiva');
    this.fichaSaude.deficienciaFisica && lista.push('Fisica');
    this.fichaSaude.deficienciaIntelectual && lista.push('Intelectual');
    this.fichaSaude.deficienciaMultipla && lista.push('Multipla');
    this.fichaSaude.deficienciaPsicossocial && lista.push('Psicossocial');
    this.fichaSaude.deficienciaVisual && lista.push('Visual');

    this.fichaSaude.tiposDeficiencias = lista;

    this.escolaOrigemId = this.escolaOrigemId?.value ? this.escolaOrigemId?.value : this.escolaOrigemId;
    return this;
  }
}



class FichaSaude {
  constructor({
    id = '00000000-0000-0000-0000-000000000000',
    planoDeSaude = '',
    numeroCarteirinha = '',
    diabetes = false,
    medicamentoContinuo = false,
    nomeMedicamento = '',
    motivoMedicamento = '',
    alergia = false,
    especificaoAlergia = '',
    intoleranciaLactose = false,
    intoleranciaGluten = false,
    refluxo = false,
    deficiencia = false,
    especificacaoDeficiencia = '',
    tiposDeficiencias = [],
    observacoes = '',
    matriculaId = ''}) {
      this.id = id;
      this.planoDeSaude = planoDeSaude;
      this.numeroCarteirinha = numeroCarteirinha;
      this.diabetes = diabetes;
      this.medicamentoContinuo = medicamentoContinuo;
      this.nomeMedicamento = nomeMedicamento;
      this.motivoMedicamento = motivoMedicamento;
      this.alergia = alergia;
      this.especificaoAlergia = especificaoAlergia;
      this.intoleranciaLactose = intoleranciaLactose;
      this.intoleranciaGluten = intoleranciaGluten;
      this.refluxo = refluxo;
      this.deficiencia = deficiencia;
      this.especificacaoDeficiencia = especificacaoDeficiencia;
      this.tiposDeficiencias = tiposDeficiencias;
      this.observacoes = observacoes;
      this.matriculaId = matriculaId;
      this.deficienciaAuditiva = true;
      this.deficienciaAuditiva = this.verificarDeficiencia("Auditiva");
      this.deficienciaFisica = this.verificarDeficiencia("Fisica");
      this.deficienciaIntelectual = this.verificarDeficiencia("Intelectual");
      this.deficienciaMultipla = this.verificarDeficiencia("Multipla");
      this.deficienciaPsicossocial = this.verificarDeficiencia("Psicossocial");
      this.deficienciaVisual = this.verificarDeficiencia("Visual");
  }

  verificarDeficiencia(tipo){
    return this.tiposDeficiencias.includes(tipo);
  }
}
